import { TRootState, TStoragesState } from '../../types'
import { createSelector } from '@reduxjs/toolkit'
import { storagesAdapter } from './adapter'

const selectState = (state: TRootState): TStoragesState => state.storages

const adapterSelectors = storagesAdapter.getSelectors(selectState)

const fetchStatus = createSelector(
    selectState,
    (state) => ({
        isFetching: state.isFetching,
        error: state.fetchError,
    })
)

const totalItems = createSelector(
    selectState,
    (state) => (state.totalItems)
)


export const selectors = {
    ...adapterSelectors,
    fetchStatus,
    totalItems,
}